/* eslint-disable */

import store from '@vuex'
import axios from 'axios'

const axiosInstance = axios.create({
  baseURL: process.env.USDT_LISTENER_SERVER,
  headers: {
    'Content-Type': 'application/json'
  },
});

  axiosInstance.interceptors.request.use(
    async (config) => {
      const token = sessionStorage.getItem('token');
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      if (config.url !== '/auth/refresh') {
        try {
          const refreshToken = sessionStorage.getItem('token');
          axiosInstance.defaults.headers['Authorization'] = `Bearer ${refreshToken}`;
          const { data } = await axiosInstance.post('/auth/refresh');
          sessionStorage.setItem('token', data.token);
          axiosInstance.defaults.headers['Authorization'] = `Bearer ${data.token}`;
        } catch (e) {
          if (e.response && e.response.status === 401) {
            store.dispatch('LOG_OUT')
          }
        }
      }
      return config
    },
    async (error) => {
      return Promise.reject(error);
    }
  )

  axiosInstance.interceptors.response.use(
    (response) => {
      return response
    },
    (error) => {
      if (error.response && error.response.status === 401) {
        store.dispatch('LOG_OUT')
      }
      return Promise.reject(error);
    }
  )
  
  const apiHelper = {
    get: (url, params = {}) => {
      return axiosInstance.get(url, { params });
    },
  
    post: (url, data) => {
      return axiosInstance.post(url, data);
    },
  
    put: (url, data) => {
      return axiosInstance.put(url, data);
    },
  
    delete: (url) => {
      return axiosInstance.delete(url);
    },
  };

export default apiHelper


// WEBPACK FOOTER //
// ./src/js/utils/cunstomInterseptor.js